/**
 * Error Message Configuration
 * Provides user-friendly error messages instead of technical errors
 */

export interface ErrorMessageConfig {
  connection: {
    offline: string;
    timeout: string;
    failed: string;
    retrying: string;
  };
  backend: {
    unavailable: string;
    configFailed: string;
    serviceError: string;
  };
  user: {
    networkIssue: string;
    retryPrompt: string;
  };
}

export const getErrorMessageConfig = (): ErrorMessageConfig => ({
  connection: {
    offline: process.env.REACT_APP_ERROR_BACKEND_OFFLINE || 
             'AI Assistant is temporarily unavailable. Please check your internet connection and try again.',
    timeout: 'Connection timed out. Please try again.',
    failed: process.env.REACT_APP_ERROR_CONNECTION_FAILED || 
            'Connection lost - attempting to reconnect...',
    retrying: 'Reconnecting...',
  },
  backend: {
    unavailable: 'Service temporarily unavailable. We\'re working to restore it.',
    configFailed: process.env.REACT_APP_ERROR_CONFIG_FAILED || 
                  'Unable to load configuration. Using default settings.',
    serviceError: 'Service error occurred. Please try again in a moment.',
  },
  user: {
    networkIssue: process.env.REACT_APP_ERROR_NETWORK_ISSUE || 
                  'Network connection issue. Please check your internet connection.',
    retryPrompt: process.env.REACT_APP_ERROR_RETRY_PROMPT || 
                 'Click to retry connection',
  },
});

export const DEFAULT_ERROR_MESSAGES = getErrorMessageConfig();
